import React, {useContext, useEffect, useReducer} from 'react'
import PropTypes from 'prop-types';
import {Paper} from "@material-ui/core";
import {insert} from 'object-path-immutable';
import ScreenCharts from "./ScreenCharts/ScreenCharts";
import TableList from "./Table";
import {ScreenDesignerListProvider} from "../../../../../../../../ContextComponents/ScreenDesignerListContext";
import request from "../../../../../../../../Services/API/Requests";
import {makePivotColumns} from "../../../../../../../../Utils/ListUtils/generatePivotColumns";
import {makePivotData} from "../../../../../../../../Utils/ListUtils/generatePivotData";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";

const ACTIONS = {
    SET_DATA: 'set-data',
    TOGGLE_LOADING: 'toggle-loading',
    SET_SCHEMA: 'set-schema'
};
const initialSchema = {
    columns: [],
    label: '',
    pivotRows: [],
    pivotValues: [],
    pivotColumns: [],
    gridProps: {},
    chartProps: {},
    presentation: "grid"
};
const initialState = {
    pivotGeneratedColumns: [],
    pivotData: {},
    loading: false,
    rowsPerPage: 25,
    page: 0,
    schema: initialSchema,
    data: {
        content: [],
        totalElements: 0
    }
};

function initState() {
    return initialState
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.SET_DATA:
            return {
                ...state,
                ...action.payload
            };
        case ACTIONS.TOGGLE_LOADING:
            return {
                ...state,
                loading: !state.loading
            };
        case ACTIONS.SET_SCHEMA:
            return {
                ...state,
                schema: action.payload.schema
            }
        default:
            return state;
    }
}

const EnqueryList = (props) => {
    const [state, dispatch] = useReducer(reducer, undefined, initState);
    const {preparedToSaveLists, prepareToSaveLists} = useContext(ScreenDesignerContextNew);
    const {list, properties, setListData} = props;
    const listSchema = preparedToSaveLists[properties.name] ? preparedToSaveLists[properties.name].schema : initialSchema;
    const styles = list.styles ? list.styles[0] : {};
    const listStyles = generateListStyles(styles);

    useEffect(() => {
        initData()
    }, [properties.name]);

    async function initData() {
        try {
            dispatch({type: ACTIONS.TOGGLE_LOADING});
            const {schema, touched} = await getSchema();
            console.log(touched)
            dispatch({
                type: ACTIONS.SET_SCHEMA,
                payload: {schema: schema}
            });
            setListData({columns: schema.columns, filterFields: schema.filterFields}, properties.name);
            prepareToSaveLists({
                schema,
                touched
            }, properties.name);
            await getData(schema);
            dispatch({type: ACTIONS.TOGGLE_LOADING});
        } catch (e) {
            console.log(e)
            dispatch({type: ACTIONS.TOGGLE_LOADING});
        }
    }

    async function getSchema() {

        try {
            if (properties.name) {
                if (preparedToSaveLists[properties.name] && preparedToSaveLists[properties.name].schema) {
                    return {
                        schema: preparedToSaveLists[properties.name]?.schema,
                        touched: true
                    }
                }
                return {
                    schema: await request({
                        url: "list/read",
                        method: "POST",
                        data: {id: properties.name}
                    }),
                    touched: false
                }
            }
            return initialSchema;
        } catch (e) {
            console.log(e)
        }
    }

    async function getData({rows, values, pivotColumns, columns}) {
        let pivotGeneratedColumns = [];
        let pivotData = {};
        try {
            if (properties.name) {
                const data = await request({
                    url: "list/getData",
                    method: "POST",
                    data: {id: properties.name}
                });
                if (rows && rows.length && values && values.length) {
                    pivotGeneratedColumns = makePivotColumns(data.content, rows, values, pivotColumns, columns);
                    pivotData = makePivotData(data.content, rows, values, pivotColumns, columns, pivotGeneratedColumns)
                }
                dispatch({
                    type: ACTIONS.SET_DATA,
                    payload: {
                        data,
                        pivotGeneratedColumns,
                        pivotData
                    }
                });
            }
        } catch (e) {
            console.log(e)
        }
    }

    function updateListSchema(path, value, index) {
        const newListSchema = insert(listSchema, path, value, index);
        prepareToSaveLists({
            schema: newListSchema,
            touched: true
        }, properties.name);
    }

    return (
        <Paper style={{...listStyles}}>
            <ScreenDesignerListProvider
                value={{
                    ...listSchema,
                    ...props,
                    page: state.page,
                    rowsPerPage: state.rowsPerPage,
                    data: state.data,
                    pivotGeneratedColumns: state.pivotGeneratedColumns,
                    pivotData: state.pivotData,
                    updateListSchema
                }}
            >
                {listSchema.presentation === 'grid' || listSchema.presentation === undefined ? (
                    <TableList/>
                ) : (
                    <ScreenCharts/>
                )}
            </ScreenDesignerListProvider>
        </Paper>
    )
};

export default EnqueryList;

EnqueryList.propTypes = {
    list: PropTypes.object,
    properties: PropTypes.object,
    setListData: PropTypes.func
};

function generateShadowBox(styles) {
    const isCustomBoxShadow =
        styles.shadowBoxBlur || styles.shadowBoxHorizontal || styles.shadowBoxVertical || styles.shadowBoxSpread;
    const defaultShadowBox = `0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)`;
    const customShadowBox = `${styles.shadowBoxVertical || '0'}px ${styles.shadowBoxHorizontal || '0'}px ${styles.shadowBoxBlur || '0'}px ${styles.shadowBoxSpread || '0'}px ${styles.shadowColor || ''}`;
    return {
        isCustomBoxShadow,
        defaultShadowBox,
        customShadowBox
    }
}

function generateListStyles(styles) {
    const {customShadowBox, defaultShadowBox, isCustomBoxShadow} = generateShadowBox(styles);
    return {
        overflowX: 'auto',
        overflowY: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: styles.minHeight ? styles.minHeight : 0,
        borderTop: `${styles.borderTop}px solid`,
        borderRight: `${styles.borderRight}px solid`,
        borderBottom: `${styles.borderBottom}px solid`,
        borderLeft: `${styles.borderLeft}px solid`,
        borderColor: styles.borderColor,
        width: '100%',
        // padding: styles.padding,
        shadowColor: styles.shadowColor,
        boxShadow: isCustomBoxShadow ? customShadowBox : defaultShadowBox
    }
}
